import { Moment, parseZone } from "moment";
import { Component, Inject, Input, OnInit, Optional } from "@angular/core";
import { MealService } from "../meal.service";
import { DrawerRef, DRAWER_DATA_VAR } from "mis-design-system/drawer";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";
import { ConfigurationService } from "../../../services/configuration.service";
import { take, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { LoaderService } from "../../../services/loader.service";
import { MealStylePipe } from "../meal-style.pipe";
import { ToastService } from "mis-crystal-design-system/toast";

@Component({
  selector: "mis-employee-web-exp-meal-option",
  templateUrl: "./meal-option.component.html",
  styleUrls: ["./meal-option.component.scss"]
})
export class MealOptionComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  selectedItem: NsEmpWebExpData.IMeal;
  mealMap = new Map<string, NsEmpWebExpData.IMealMapType>();
  mealData: NsEmpWebExpData.IMeal[] = [];
  private endObs = new Subject<void>();
  mealStartCutOff: number;
  mealEndCutOff: number;
  mealCutOffPassed: boolean = false;

  constructor(
    private toasts: ToastService,
    private mealService: MealService,
    @Optional() private drawerRef: DrawerRef,
    public configSvc: ConfigurationService,
    private loader: LoaderService,
    @Optional() @Inject(DRAWER_DATA_VAR) data
  ) {
    if (this.configSvc.isMobile) this.selectedItem = data;
  }
  ngOnInit() {
    this.mealService.startEndTime.pipe(takeUntil(this.endObs)).subscribe(res => {
      this.getHoursAndMiutes(res);
    });
    this.mealService.selectedMealItem.subscribe(res => {
      res ? (this.selectedItem = res) : (this.selectedItem = this.selectedItem);
      this.openPremise(res);
    });
    this.mealService.mealData.pipe(takeUntil(this.endObs)).subscribe(response => {
      this.mealData = response;
      this.mealService.bookingRes.pipe(take(1)).subscribe(res => {
        if (res) {
          this.mealSelection(null, null, res);
        }
      });
    });
  }

  getHoursAndMiutes(data) {
    this.mealStartCutOff = Math.floor(parseZone(data.startShift).tz(data.timeZone).diff(parseZone(data.startShift).startOf("day")) / 60000);
    this.mealEndCutOff = Math.floor(parseZone(data.endShift).tz(data.timeZone).diff(parseZone(data.endShift).startOf("day")) / 60000);
  }
  openPremise(item: NsEmpWebExpData.IMeal) {
    if (item) this.selectedItem = item;
    else this.selectedItem = this.mealData[0];
    this.setCutoffForMeal(this.selectedItem);
  }

  setCutoffForMeal(data) {
    this.selectedItem = data;
    data.meals.forEach((element, index) => {
      if (element.mealStartTime == null && element.mealEndTime == null) {
        this.selectedItem.meals[index]["mealCutOff"] = true;
      } else {
        (element.mealStartTime >= this.mealStartCutOff && element.mealStartTime <= this.mealEndCutOff) ||
        (element.mealEndTime >= this.mealStartCutOff && element.mealEndTime <= this.mealEndCutOff) ||
        (this.mealStartCutOff >= element.mealStartTime && this.mealEndCutOff <= element.mealEndTime)
          ? (this.mealCutOffPassed = true)
          : (this.mealCutOffPassed = false);
        this.selectedItem.meals[index]["mealCutOff"] = this.mealCutOffPassed;
      }
    });
  }
  cutOffMealSelection(item) {
    this.toasts.displayMsg(`The latest time upto which you can book ${item?.name} is already passed.`, 4000);
  }
  close() {
    this.drawerRef.close();
  }
  structuringInit(data: NsEmpWebExpData.IMeal[]) {
    this.mealMap.clear();
    data.length
      ? Array.from(data[0].mealMap.values()).map(item => {
          this.mealMap.set(item.mealId, {
            name: item.name,
            status: item.status,
            mealSelection: item.mealOption,
            mealId: item.mealId,
            premiseEndTime: data[0].premiseEndTime,
            premiseId: data[0].premiseId,
            premiseName: data[0].premiseName,
            premiseStartTime: data[0].premiseStartTime
          });
        })
      : this.mealMap.clear();
    this.mealMap = new Map(this.mealMap.entries());
  }
  initialSelectionHandler(data: NsEmpWebExpData.IMeal[]) {
    this.structuringInit(data);
    this.mealService.changeRes.pipe(takeUntil(this.endObs)).subscribe(res => {
      this.structuringInit(res);
    });
  }
  mealSelection(data?: NsEmpWebExpData.IMealsEntity, typename?: NsEmpWebExpData.IMealOption, initSelection?: NsEmpWebExpData.IMeal[]) {
    if (!data?.mealCutOff && data != null) {
      this.cutOffMealSelection(data);
    } else {
      if (initSelection?.length > 0) {
        this.initialSelectionHandler(initSelection);
      } else if (data !== null && typename !== null) {
        const mealResponse = {
          name: data.name,
          status: data.status,
          mealSelection: { [typename.key]: typename.value },
          mealId: data.mealId,
          premiseEndTime: this.selectedItem["premiseEndTime"],
          premiseId: this.selectedItem["premiseId"],
          premiseName: this.selectedItem["premiseName"],
          premiseStartTime: this.selectedItem["premiseStartTime"]
        };
        //premise change check for web view
        if (this.mealMap.size > 0 && !this.configSvc.isMobile && Array.from(this.mealMap.entries())[0][1].premiseId !== this.selectedItem.premiseId) {
          this.mealMap.clear();
        }
        // deselecting meal option
        this.mealMap.has(data.mealId) && Object.entries(this.mealMap.get(data.mealId)?.mealSelection)[0][1] === typename["value"]
          ? this.mealMap.delete(data.mealId)
          : this.mealMap.set(data.mealId, mealResponse);
        this.mealMap = new Map(this.mealMap.entries());
        if (!this.configSvc.isMobile) {
          this.mealService.changeRes.pipe(takeUntil(this.endObs)).subscribe(res => {
            this.structuringInit(res);
          });
          this.mealService.setMealData(this.structuringResponse());
        }
      }
    }
  }
  structuringResponse() {
    const optedMealData = Array.from(this.mealMap.values());
    const mealDataObj = new Array();
    optedMealData.map(item => {
      mealDataObj.push({ mealOption: item.mealSelection, mealId: item.mealId, name: item.name, status: item.status });
    });
    const finalObj = new Array();
    finalObj.push({
      mealData: mealDataObj,
      premiseEndTime: this.selectedItem.premiseEndTime,
      premiseId: this.selectedItem.premiseId,
      premiseName: this.selectedItem.premiseName,
      premiseStartTime: this.selectedItem.premiseStartTime
    });
    return finalObj;
  }
  saveSelection() {
    this.mealService.setMealData(this.structuringResponse());
    this.drawerRef?.close("DONE");
  }
  ngOnDestroy(): void {
    this.endObs.next();
    this.endObs.complete();
  }
}
